import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import { ComponentSettingsInterface, StageComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import MBWStageSettings from '../../../templates/MBW/MBWStageSettings';
import SidebarToolbar from '../../SidebarToolbar';
import SettingsTemplate from '../SettingsTemplate';
import StageSettingsTable from './StageSettingsTable';
import StageStyling from './StageStyling';
import { mbwCustomTemplateOrgId } from '../../../../../static/constants';
import MBWStageStyling from '../../../templates/MBW/MBWStageStyling';

const StageSettings = ({ onClose, component, onChange }: ComponentSettingsInterface<StageComponentInterface>) => {
  const showVisibilitySettings = useSelector((state) => state.common.showVisibilitySettings);
  const organization = useSelector((state) => state.common.event?.organization ?? state.admin.event?.organization);
  const [selectedTab, setSelectedTab] = useState<number>(showVisibilitySettings ? 2 : 0);

  const { t } = useTranslation();

  return (
    <>
      <SidebarToolbar name={t('pagebuilder:stage')} onClose={onClose} value={selectedTab} onChange={(e, newValue: number) => setSelectedTab(newValue)} />
      <SettingsTemplate
        selectedTab={selectedTab}
        component={component}
        onChange={onChange}
        hasDefaultPadding={false}
        StylingChildren={
          mbwCustomTemplateOrgId === organization?._id ? (
            <MBWStageStyling component={component} onChange={onChange} />
          ) : (
            <StageStyling component={component} onChange={onChange} />
          )
        }>
        <StageSettingsTable onChange={onChange} component={component} />
        {component.theme === 'mbw' && <MBWStageSettings component={component} onChange={onChange} />}
      </SettingsTemplate>
    </>
  );
};
export default StageSettings;
